import React from "react";
import { Link } from "gatsby";
import { StaticImage } from "gatsby-plugin-image";

import Facebook from "../images/svg/facebook.svg";
import Instagram from "../images/svg/instagram.svg";
import Twitter from "../images/svg/twitter.svg";

const Footer = () => {
  return (
    <footer className="footer content-container">
      <div className="footer-content">
        <Link to="/" className="footer-logo">
          <StaticImage
            src="../images/BOO-logo.png"
            alt="Branch Out Online logo"
            className="logo"
            placeholder="blurred"
          />
        </Link>
        <section className="footer-services">
          <h4>
            <Link to="/services">Services</Link>
          </h4>
          <ul>
            <li>
              <Link to="/services">Website Design</Link>
            </li>
            <li>
              <Link to="/services">Website Development</Link>
            </li>
          </ul>
        </section>
        <section className="footer-contact">
          <h4>Contact</h4>
          <p>
            We'd love to help you branch out online! Please fill out the contact
            form linked below and we will get in touch.
          </p>
          <Link to="/contact" className="footer-btn">
            Get in touch
          </Link>
        </section>
        <section className="footer-socials">
          <h4>Socials</h4>
          <div className="footer-social-icons">
            {/* <a
              href="https://www.facebook.com/branchoutonline"
              rel="noreferrer"
              target="_blank"
              className="footer-social-icon"
              aria-label="Facebook"
            >
              <Facebook className="footer-social-icon" />
            </a>
            <a
              href="https://www.instagram.com/branchoutonline/"
              rel="noreferrer"
              target="_blank"
              className="footer-social-icon"
              aria-label="Instagram"
            >
              <Instagram className="footer-social-icon" />
            </a>
            <a
              href="https://twitter.com/branch_oonline"
              rel="noreferrer"
              target="_blank"
              className="footer-social-icon"
              aria-label="Twitter"
            >
              <Twitter className="footer-social-icon" />
            </a> */}
            <p>Coming soon...</p>
          </div>
        </section>
      </div>
      <p className="footer-subtxt">
        Made with &#9829; by Branch Out Online | 2021
      </p>
    </footer>
  );
};

export default Footer;
